import React from 'react';
import ProjectIconUI5 from "../../../../core/gd-components/icons/project/project-icon-ui5";

export default function TeamProjectsGList_ProjectName(record: any) {

    return (
        <div className="flex-row-left-center p-l-8">
            <ProjectIconUI5 project={record.model}/>
            <div className="ui5-txt-less-important m-l-10">{record.model.name}</div>
        </div>
    );
}
